module.exports = __webpack_public_path__ + "media/images/village/career-camp-2022/icons-7816dc6326630aef677a67c6dba4d856.svg";